module.exports = __webpack_public_path__ + "static/media/icone-main.b89f7155.svg";